// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"5697f46b","47":"dfe1b5c3","197":"30064cfa","245":"5eed00bf","300":"75c094b5","363":"12fcff8b","374":"34d1f2db","436":"2d122259","486":"9530f2f5","542":"8ecfd2a2","681":"3e8b1522","714":"6d6be50a","841":"9bc2d12e","911":"5da68dbd"}[chunkId] + ".chunk.js";
};